module.exports = __webpack_public_path__ + "img/activity_slogan_img.b9320679.png";